export const centsToDollars = (cents) => {
  const dollarAmount = cents / 100;
  return dollarAmount.toFixed(2);
};
